module.exports = __webpack_public_path__ + "static/media/popover_read.3ee00658.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/popover_read.png
// module id = 1847
// module chunks = 0 1